import { dispatch as trackEvent } from '@ynap/analytics'
import { track3DSV2Initialised, track3DSV2Fingerprint, track3DSV2Challenge } from './analytics'

export const AdyenSDKLoader = (useMock = true) => {
    const initSDK = (adyenModule) => {
        if (adyenModule.AdyenCheckout) {
            if (window) {
                window.AdyenSdkLoaded = true
            }
            console.log('Adyen 3DS 2.0 SDK has been successfully loaded')
        }
        return adyenModule.AdyenCheckout
    }

    // Load mocked sdk from websdk-test.js
    return useMock ? import('./websdk-test').then(initSDK) : import('./websdk').then(initSDK)
}

export const fingerprintRunner = async (token, useMock) => {
    const AdyenCheckout = await AdyenSDKLoader(useMock)

    const checkout = new AdyenCheckout()

    return new Promise((resolve, reject) => {
        trackEvent(track3DSV2Initialised('fingerprint'))
        //Mount sdk fingerprint component
        checkout
            .create('threeDS2DeviceFingerprint', {
                fingerprintToken: token,
                onComplete: function(result) {
                    resolve(result.data.details['threeds2.fingerprint'])
                    trackEvent(track3DSV2Fingerprint())
                }, // Called whenever a result is available, regardless if the outcome is successful or not.
                onError: function(e) {
                    console.log('fingerprintRunner error = ', e)
                    // reject(e)
                } // Gets triggered on error.
            })
            .mount('#threeDS2')
    })
}

export const challengeRunner = async (token, useMock) => {
    const AdyenCheckout = await AdyenSDKLoader(useMock)
    const checkout = new AdyenCheckout()

    if (window) {
        window.showChallenge = true
    }

    return new Promise((resolve, reject) => {
        trackEvent(track3DSV2Initialised('challenge'))
        //Mount sdk challenge component
        checkout
            .create('threeDS2Challenge', {
                challengeToken: token,
                onComplete: function(result) {
                    window.showChallenge = false
                    resolve(result.data.details['threeds2.challengeResult'])
                    trackEvent(track3DSV2Challenge())
                }, // Called whenever a result is available, regardless if the outcome is successful or not.
                onError: function(e) {
                    window.showChallenge = false
                    reject(e)
                }, // Gets triggered on error.
                size: '05'
            })
            .mount('#threeDS2')
    })
}

export const collectBrowserInfo = () => {
    const screenWidth = window && window.screen ? window.screen.width : ''
    const screenHeight = window && window.screen ? window.screen.height : ''
    const colorDepth = window && window.screen ? window.screen.colorDepth : ''
    const userAgent = window && window.navigator ? window.navigator.userAgent : ''
    const javaEnabled = window && window.navigator ? navigator.javaEnabled?.() || false : false

    let language = ''
    if (window && window.navigator) {
        language = window.navigator.language ? window.navigator.language : window.navigator.browserLanguage // Else is for IE <+ 10
    }

    const d = new Date()
    const timeZoneOffset = d.getTimezoneOffset()

    let browserInfo = {
        screenWidth: String(screenWidth),
        screenHeight: String(screenHeight),
        colorDepth: String(colorDepth),
        userAgent: String(userAgent),
        timeZoneOffset: String(timeZoneOffset),
        language: String(language),
        javaEnabled: String(javaEnabled)
    }

    return browserInfo
}

export const browserInfoKeys = ['screenWidth', 'screenHeight', 'colorDepth', 'userAgent', 'timeZoneOffset', 'language', 'javaEnabled']

export const isValidBrowserInfo = (ob) => {
    if (!ob) return false
    return browserInfoKeys.every((key) => typeof ob[key] !== 'undefined')
}
